import React, { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { Grid } from "@material-ui/core";
import { ImageList } from "@mui/material";
import { Alert } from "@material-ui/lab";
import { messages } from "./VideoSettings.messages";
import VideoFilterUploadButton from "../../../../../../Components/Buttons/VideoFilterUploadButton/VideoFilterUploadButton";
import {
  userPreferencesService,
  videoFilterService,
} from "../../../../../../Providers/ServiceProvider/ServiceProvider";
import { useCustomerId } from "../../../../../../Providers/CustomerProvider/CustomerProvider";
import { PaginatedFilterList } from "../../../../../../generated/video-api";
import CustomPagination from "../../../../../../Components/CustomPagination/Pagination";
import BackgroundImageItem from "./Components/BackgroundImageItem/BackgroundImageItem";
import {
  UserPreferencesResponse,
  UserVideoBackgroundType,
} from "../../../../../../generated/user-preferences-api";
import CardHeading from "../../../../../../Components/CardHeading/CardHeading";

interface Props {
  userId: string;
  disableUpload?: boolean;
}

const VideoSettings = (props: Props) => {
  const { userId, disableUpload } = props;
  const intl = useIntl();
  const customerId = useCustomerId();
  const [page, setPage] = useState<number>(1);
  const [
    userPreferences,
    setUserPrefrences,
  ] = useState<UserPreferencesResponse>();
  const [paginatedFilter, setPaginatedFilter] = useState<PaginatedFilterList>();

  const loadVideoFilterList = () => {
    if (customerId) {
      videoFilterService()
        .listfilter({
          customerId,
          page,
          pageSize: page === 1 ? 3 : 5,
        })
        .then((res) => {
          setPaginatedFilter(res);
        });
    }
  };

  const loadUserPreferences = () => {
    if (customerId) {
      userPreferencesService()
        .getPreferences({ userId })
        .then((res) => setUserPrefrences(res));
    }
  };

  useEffect(() => {
    loadUserPreferences();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    loadVideoFilterList();
  }, [page]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Grid container>
      <CardHeading noMarginBottom>
        {intl.formatMessage(messages.title).toUpperCase()}
      </CardHeading>
      <Alert severity="info" variant="standard">
        {intl.formatMessage(messages.alertInfo)}
      </Alert>
      <Grid item xs={12}>
        {!disableUpload && (
          <VideoFilterUploadButton
            variant="text"
            onFileUploaded={() => loadVideoFilterList()}
          />
        )}
      </Grid>
      <Grid item xs={12}>
        {paginatedFilter && paginatedFilter.data && userPreferences && (
          <>
            <ImageList variant="standard" cols={5} gap={8}>
              {page === 1 && (
                <BackgroundImageItem
                  userId={userId}
                  type={UserVideoBackgroundType.None}
                  selectedFilterType={userPreferences.videoBackgroundType}
                  onSelected={loadUserPreferences}
                />
              )}
              {page === 1 && (
                <BackgroundImageItem
                  userId={userId}
                  type={UserVideoBackgroundType.Blur}
                  selectedFilterType={userPreferences.videoBackgroundType}
                  onSelected={loadUserPreferences}
                />
              )}
              {paginatedFilter.data.map((file) => (
                <BackgroundImageItem
                  userId={userId}
                  type={UserVideoBackgroundType.File}
                  file={file}
                  selectedFilterType={userPreferences.videoBackgroundType}
                  selectedFilterFileId={userPreferences?.videoBackgroundFileId}
                  onSelected={loadUserPreferences}
                />
              ))}
            </ImageList>
            <CustomPagination
              onChange={setPage}
              pagination={paginatedFilter?.pagination}
            />
          </>
        )}
      </Grid>
    </Grid>
  );
};

export default VideoSettings;
